import React from 'react';
import * as Sentry from '@sentry/nextjs';

import { CUSTOM_TAGS_NAME, CUSTOM_TAGS_VALUE } from '../../constants/sentry_custom_tags';

class ErrorBoundary extends React.Component<Record<string, unknown>, { hasError: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: unknown, errorInfo: unknown) {
    console.error(error, errorInfo);
    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setTag(CUSTOM_TAGS_NAME.pdp, CUSTOM_TAGS_VALUE.error_boundary);
      Sentry.captureException(error);
    });
  }

  override render() {
    if (this.state.hasError) {
      return null;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{this.props.children}</>;
  }
}

export const ErrorBoundaryWrapper: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};
